import {AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';

@Component({
  selector: 'app-image-panolens',
  templateUrl: './image-panolens.component.html',
  styleUrls: ['./image-panolens.component.scss']
})
export class ImagePanolensComponent implements AfterViewInit, OnDestroy {

  private viewer;
  private panorama;

  @ViewChild('panolens', {static: false, read: ElementRef})
  panolensContainer: ElementRef;

  private _imageSrc: string;
  @Input()
  set imageSrc(val: string) {
    this._imageSrc = val;
    if (this.viewer) {
      this.clean();
      setTimeout(() => {
        this.initViewer();
      });
    }
  }

  get imageSrc(): string {
    return this._imageSrc;
  }

  constructor() {
  }

  ngOnDestroy() {
    this.clean();
  }

  ngAfterViewInit() {
    this.initViewer();
  }

  clean(): void {
    if (this.viewer) {
      this.viewer.renderer.dispose();
      this.viewer.renderer.forceContextLoss();
      this.viewer.clearAllCache();
      this.viewer.destroy();
      this.panorama = null;
      this.viewer = null;
    }
  }

  private initViewer(): void {
    this.viewer = new PANOLENS.Viewer({
      controlBar: false,
      output: 'console',
      viewIndicator: true,
      container: this.panolensContainer.nativeElement
    });

    this.panorama = new PANOLENS.ImagePanorama(this.imageSrc);
    this.viewer.add(this.panorama);
  }
}
